module.exports = __webpack_public_path__ + "static/img/bg_Bill_texture.0480dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/bg_Bill_texture.png
// module id = mVbe
// module chunks = 69